import { Stack, Typography } from "@mui/material";
import UserAvatar from "@entrilia/shared/components/UserAvatar";

interface Props {
  name: string;
  email: string;
  isCurrentUser: boolean;
  iconSize: "small" | "medium";
}
const AuthorizationUserItem = ({ name, email, isCurrentUser, iconSize }: Props) => {
  return (
    <Stack direction={"row"} spacing={1.5} sx={{ alignItems: "center" }}>
      <UserAvatar userName={name} size={iconSize} />
      <Stack>
        <Stack direction={"row"} spacing={0.5}>
          <Typography variant="body2">{name}</Typography>
          {isCurrentUser ? (
            <Typography variant="body2" color={"secondary"}>
              (You)
            </Typography>
          ) : (
            ""
          )}
        </Stack>
        <Typography variant="caption" color="textSecondary">
          {email}
        </Typography>
      </Stack>
    </Stack>
  );
};
export default AuthorizationUserItem;
